import { Injectable, OnDestroy, TemplateRef } from '@angular/core';
import { MatBottomSheet, MatBottomSheetConfig, MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

interface BottomDrawerState {
  drawerContent: TemplateRef<any>;
  config: MatBottomSheetConfig<any>;
}

@Injectable({
  providedIn: 'root'
})
export class BottomDrawerManageService implements OnDestroy {

  private bottomDrawerStatesStack: BottomDrawerState[] = [];

  private unsub$: Subject<void> = new Subject();

  constructor(private _bottomSheet: MatBottomSheet) { }

  get drawersStackLength(): number {
    return this.bottomDrawerStatesStack.length;
  }

  public ngOnDestroy(): void {
    this.unsub$.next();
    this.unsub$.complete();
  }

  public openDrawer(
    drawerContent: TemplateRef<any>, 
    config: MatBottomSheetConfig<any>,
  ): void {
    this.bottomDrawerStatesStack.push({drawerContent, config});
    this.createDrawer(drawerContent, config);
  }

  public closeDrawer(): void {
    this._bottomSheet.dismiss();
    this.bottomDrawerStatesStack.pop();

    if (this.bottomDrawerStatesStack.length) {
      // reopen previous modal
      const { drawerContent, config } = this.bottomDrawerStatesStack[this.bottomDrawerStatesStack.length - 1];
      this.createDrawer(drawerContent, config);
    }
  }

  public closeAllDrawers(): void {
    this.bottomDrawerStatesStack = [];
    this._bottomSheet.dismiss();
  }

  private createDrawer(drawerContent: TemplateRef<any>, config: MatBottomSheetConfig<any>,) {
    // handle backdrop clicks
    this._bottomSheet.open(drawerContent, config)?.backdropClick().pipe(
      takeUntil(this.unsub$)
    ).subscribe(() => this.closeAllDrawers());
  }
}
